import { ServerResponse, Tokens } from '@/types'

import { api } from '../api'

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    signIn: builder.mutation<Tokens, { login: string; password: string }>({
      query: (body) => ({
        url: 'login',
        method: 'POST',
        body,
      }),
      transformResponse: (response: ServerResponse<Tokens>) => response.data,
    }),
    signOut: builder.mutation<{ status: string }, any>({
      query: () => ({
        url: 'logout',
        method: 'POST',
      }),
    }),
    sendResetEmail: builder.mutation<{ status: string }, { callbackUrl: string; email: string }>({
      query: (body) => ({
        url: '/password/reset/link',
        method: 'POST',
        body,
      }),
    }),
    resetPassword: builder.mutation<{ status: string }, { token: string; email: string; password: string; repeatedPassword: string }>({
      query: (body) => ({
        url: '/password/reset',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useSignInMutation, useSignOutMutation, useSendResetEmailMutation, useResetPasswordMutation } = authApi
